export function assertUnreachable(x) {
    throw new Error(`unreachable: ${String(x)}`);
}
export function assertNotNull(value) {
    if (value === null) {
        throw new Error('unexpected null value');
    }
    if (value === undefined) {
        throw new Error('unexpected undefined value');
    }
}
export function assert(value, message) {
    if (!value) {
        throw new Error(`unreachable${message ? `: ${message}` : ''}`);
    }
}
//# sourceMappingURL=assert.js.map